import { render } from "./AdminInquiries.vue?vue&type=template&id=14daaacc&scoped=true"
import script from "./AdminInquiries.vue?vue&type=script&lang=js"
export * from "./AdminInquiries.vue?vue&type=script&lang=js"

import "./AdminInquiries.vue?vue&type=style&index=0&id=14daaacc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14daaacc"]])

export default __exports__